import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Box, Button, Header, Text, Tip } from 'grommet';
import { Element as ElementIcon } from '@hpe-design/icons-grommet';
import { useHeaderHeight } from '../utils/HeaderHeightContext';

const MenuItems = [];

const AppHeader = ({ toggleAgent }) => {
  const navigate = useNavigate();
  const { setHeaderHeight, headerRef } = useHeaderHeight();
  const [scrollY, setScrollY] = useState(0);

  const isPhone = /iPhone|Android.*Mobile/.test(navigator.userAgent);

  // Track scroll for subtle shadow only
  useEffect(() => {
    const onScroll = () => setScrollY(window.scrollY || window.pageYOffset || 0);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Update header height for MAUI safe area compensation
  useEffect(() => {
    const currentHeader = headerRef.current;
    const updateHeaderHeight = () => {
      if (currentHeader) setHeaderHeight(currentHeader.offsetHeight);
    };

    updateHeaderHeight();
    const resizeObserver = new ResizeObserver(updateHeaderHeight);
    if (currentHeader) resizeObserver.observe(currentHeader);

    return () => {
      if (currentHeader) {
        resizeObserver.unobserve(currentHeader);
        resizeObserver.disconnect();
      }
    };
  }, [headerRef, setHeaderHeight]);

  // Always transparent — MAUI handles glass
  const headerStyle = {
    backgroundColor: 'transparent',
    borderBottom: scrollY > 0
      ? '1px solid rgba(255,255,255,0.08)'
      : 'none',
    boxShadow: scrollY > 8
      ? '0 1px 4px rgba(0,0,0,0.12)'
      : 'none',
    paddingTop: isPhone ? 'env(safe-area-inset-top)' : 0,
    transition: 'border-bottom 0.2s ease, box-shadow 0.2s ease',
  };

  return (
    <Header
      id="header"
      ref={headerRef}
      fill="horizontal"
      pad={{ horizontal: 'medium', bottom: 'small', top: 'none' }}
      style={{
        zIndex: 10,
        position: 'sticky',
        top: 0,
        ...headerStyle,
      }}
    >
      <Tip content="BI Console home...">
        <Button
          onClick={() => navigate("/")}
          plain
          hoverIndicator="background-contrast"
        >
          <Box
            direction="row"
            align="center"
            gap="medium"
            pad={{ vertical: 'small', horizontal: 'xsmall' }}
            responsive={false}
          >
            <Box height="24px" justify="center" align="center">
              <ElementIcon color="brand" />
            </Box>

            <Box direction="row" gap="xsmall" align="center">
              <Text color="text-strong" weight="bold">HPE</Text>
              <Text color="text-strong" style={{ whiteSpace: 'nowrap' }}>
                BI Console
              </Text>
            </Box>
          </Box>
        </Button>
      </Tip>

      {!isPhone && MenuItems.length > 0 && (
        <Box direction="row" gap="small" align="center">
          {/* future menu items */}
        </Box>
      )}
    </Header>
  );
};

export { AppHeader as Header };



